import { render } from "./FormTextArea.vue?vue&type=template&id=621534f5&ts=true"
import script from "./FormTextArea.vue?vue&type=script&lang=ts"
export * from "./FormTextArea.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__